module.exports = __webpack_public_path__ + "files/bcdd46d8e65810b732ee5a8350360748.png";